import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import DiscountApprovalSearchAndFilterBar from './DiscountApprovalSearchAndFilterBar';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import DiscountApprovalTable from './DiscountApprovalTable';
import DiscountApprovalPaginator from './DiscountApprovalPagination';
import ConfirmUpdateDiscountStatusModal from './ConfirmUpdateDiscountStatusModal';

const DiscountApproval = () => {
    const dispatch = useAppDispatch();

    const discountListingIndex = useAppSelector(state => state.approval.pendingDiscountListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingDiscountListingAttempt());
    }, [discountListingIndex]);

    return (
        <TabPageContainer>
            <DiscountApprovalSearchAndFilterBar/>

            <DiscountApprovalTable />

            <DiscountApprovalPaginator />

            <ConfirmUpdateDiscountStatusModal />
        </TabPageContainer>
    );
};

export default DiscountApproval;
